import { Link } from 'foundations-components/transitional/components/Link';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { useLogo, useCompanyName } from '../context/PortalDataContext';
import { getIsThemePreview } from '../utils/metadata';
import { getPortalHomePath } from '../utils/getPortalHomePath';
import { jsx as _jsx } from "react/jsx-runtime";
function PortalHomeLink({
  children
}) {
  const handleClick = e => {
    if (getIsThemePreview()) {
      e.preventDefault();
    }
  };
  return /*#__PURE__*/_jsx(Link, {
    href: getPortalHomePath(),
    use: "unstyled",
    display: "flex",
    alignItems: "center",
    onClick: handleClick,
    "data-test-id": "portals-logo-home-link",
    children: children
  });
}

/**
 * Renders the portal brand logo, falling back to the company name, linked to
 * the portal home (the same destination as the 404 page's home button).
 *
 * The image uses an explicit `height` (not `maxHeight`) so that SVG logos —
 * which have no intrinsic pixel dimensions — have something to render against;
 * with only `maxHeight` they collapse to 0×0. `width: 'auto'` preserves the
 * aspect ratio, `maxWidth` caps very wide logos, and `objectFit: 'contain'`
 * letterboxes (rather than distorts) when `maxWidth` clamps the box.
 */
export function PortalLogo({
  height,
  maxWidth,
  fallbackMaxInlineSize,
  fallbackTextAlign
}) {
  const logo = useLogo();
  const companyName = useCompanyName();
  if (logo !== null && logo !== void 0 && logo.src) {
    var _ref, _logo$alt;
    return /*#__PURE__*/_jsx(PortalHomeLink, {
      children: /*#__PURE__*/_jsx("img", {
        src: logo.src,
        alt: (_ref = (_logo$alt = logo.alt) !== null && _logo$alt !== void 0 ? _logo$alt : logo.name) !== null && _ref !== void 0 ? _ref : 'Logo',
        style: {
          height,
          width: 'auto',
          maxWidth,
          objectFit: 'contain'
        }
      })
    });
  }
  if (companyName) {
    return /*#__PURE__*/_jsx(PortalHomeLink, {
      children: /*#__PURE__*/_jsx(TruncateString, {
        maxInlineSize: fallbackMaxInlineSize,
        textAlign: fallbackTextAlign
        // @ts-ignore need to set this to get font family styles
        ,
        typography: "heading-200",
        color: "text-core-default",
        "data-test-id": "portals-logo-fallback",
        children: companyName
      })
    });
  }
  return null;
}